import ruWeb from './web/ru.json';
import enWeb from './web/en.json';
import uaWeb from './web/ua.json';
import sharedWeb from './web/shared.json';

export type LangIdName = 'ru' | 'en' | 'uk';

export const langSharedData = {
    ...sharedWeb,
};

export const langs = {
    ['en']: {
        ...langSharedData,
        ...enWeb,
    },
    ['uk']: {
        ...langSharedData,
        ...uaWeb,
    },
    ['ru']: {
        ...langSharedData,
        ...ruWeb,
    },
};

export type langData = keyof typeof enWeb | keyof typeof sharedWeb;

export type langType = keyof typeof langs;

export const langString = (
    lang: keyof typeof langs,
    id: langData,
    ...args: (number | string | boolean)[]
) => {
    return langStringSystem(lang, id, true, ...args);
};

const langStringSystem = (
    lang: keyof typeof langs,
    id: langData,
    deep: boolean,
    ...args: (number | string | boolean)[]
) => {
    if ((lang as any) === 'ua') {
        lang = 'uk';
    }

    if (!getAllLangs().includes(lang)) {
        lang = 'en';
    }

    let string = langs[lang][id] as string;

    if (!string) {
        return '';
    }

    args.map((q, ii) => {
        const i = ii + 1;
        const reg = new RegExp(`%${i}%`, 'gi');

        string = string.replace(reg, String(q));
    });

    if (deep) {
        const test = string.match(new RegExp('%[a-zA-Z-_0-9]+%', 'gi'));

        test?.forEach((value, i) => {
            const res = langStringSystem(
                lang,
                value.replace(new RegExp('%', 'gi'), '') as any,
                false,
                ...args,
            );

            if (res) {
                string = string.replace(value, res);
            }
        });
    }

    return string;
};

export const allLangStrings = (id: langData, ...args: (number | string | boolean)[]) => {
    const res: string[] = [];

    Object.values(langs).forEach((data) => {
        let string = data[id] as string;

        if (!string) {
            return '';
        }

        args.map((q, ii) => {
            const i = ii + 1;
            const reg = new RegExp(`%${i}%`, 'gi');

            string = string.replace(reg, String(q));
        });

        res.push(string);
    });

    return res;
};

export const getAllLangsKeys = () => {
    const res: langData[] = [];

    Object.values(langs).forEach((data) => {
        Object.keys(data).forEach((key) => {
            const langKey = key as langData;
            if (!res.includes(langKey)) {
                res.push(langKey);
            }
        });
    });

    return res;
};

export const getAllLangs = () => {
    return Object.keys(langs) as langType[];
};

export const getAllLangData = () => {
    return langs;
};
